var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplaceElementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_3242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 12C6.4 10.3314 7.114 8.83471 8.234 7.78917L9.305 8.88484C9.522 9.10684 9.9 8.9493 9.9 8.62704V5.55485C9.9 5.35433 9.746 5.19679 9.55 5.19679H6.547C6.232 5.19679 6.078 5.58349 6.302 5.80549L7.24 6.77227C5.868 8.07562 5 9.93039 5 12C5 15.4016 7.324 18.2518 10.432 18.9822C10.873 19.0825 11.3 18.7459 11.3 18.2804C11.3 17.9439 11.069 17.6574 10.747 17.5786C8.262 16.9986 6.4 14.7213 6.4 12ZM19 12C19 8.59839 16.676 5.7482 13.568 5.01775C13.127 4.9175 12.7 5.25408 12.7 5.71956C12.7 6.05614 12.931 6.34259 13.253 6.42136C15.738 7.00143 17.6 9.27871 17.6 12C17.6 13.6686 16.886 15.1653 15.766 16.2108L14.695 15.1152C14.478 14.8932 14.1 15.0507 14.1 15.373V18.4452C14.1 18.6457 14.254 18.8032 14.45 18.8032H17.453C17.768 18.8032 17.922 18.4165 17.698 18.1945L16.76 17.2277C18.132 15.9244 19 14.0696 19 12Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_3242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceElementIcon);
export default __webpack_public_path__ + "static/media/replaceElementIcon.988547e1.svg";
export { ForwardRef as ReactComponent };